import React from 'react';
import { Grid, Stack, Typography } from 'components/ui';
import { WhiteCard } from 'components/styles_components/card';
import { FormattedMessage } from 'react-intl';
import DeleteButton from 'components/session_info/button/delete';
import useMobile from 'hooks/use_mobile';

const current = (sessionInfo) => {
  if (sessionInfo.current) {
    return (
      <>
        (<FormattedMessage id="session_info.current" />)
      </>
    );
  }
  return null;
};

const ListItem = ({ sessionInfo, onRemove }) => {
  const isMobile = useMobile();

  return (
    <WhiteCard key={sessionInfo.id}>
      <Grid container zspacing={2}>
        {isMobile ? (
          <>
            <Grid size={{ xs: 8 }} textAlign="left">
              <Stack>
                <Typography>{sessionInfo.ip}</Typography>
                <Typography>{sessionInfo.browserName}</Typography>
                <Typography>{current(sessionInfo)}</Typography>
              </Stack>
            </Grid>
            <Grid size={{ xs: 4 }} textAlign="right">
              <DeleteButton sessionInfo={sessionInfo} onRemove={onRemove} />
            </Grid>
          </>
        ) : (
          <>
            <Grid size={{ xs: 3 }} textAlign="left">
              {sessionInfo.ip} {current(sessionInfo)}
            </Grid>
            <Grid size={{ xs: 3 }} textAlign="left">
              {sessionInfo.browserName}
            </Grid>
            <Grid size={{ xs: 3 }} textAlign="left">
              {sessionInfo.browserVersion}
            </Grid>
            <Grid size={{ xs: 3 }} textAlign="right">
              <DeleteButton sessionInfo={sessionInfo} onRemove={onRemove} />
            </Grid>
          </>
        )}
      </Grid>
    </WhiteCard>
  );
};

export default ListItem;
